module.exports = __webpack_public_path__ + "img/plxz.87e92736.svg";